import { pxChangeVw } from "@/utils";
export default function Pollutants() {
  return (
    <div className="flex flex-col flex-wrap">
      <div className='relative after:content-[""] after:bg-[rgba(255,255,255,0.18)] w-[calc(100%-16px)] h-1 absolute left-50% bottom-0 translate-x-[-50%] flex-[1] flex'>
        <div className='flex-[1] text-12 flex flex-col gap-y-8 p-[8px_8px_16px] odd:relative odd:after:content-[""] odd:after:bg-[rgba(255,255,255,0.18)] odd:after:w-1 odd:after:h-80% odd:after:absolute odd:after:right-0 odd:after:top50% odd:after:translate-y-[-50%]'>
          <div
            className='relative pb-5 w-full after:content-[""] after:w-35 after:h-2 after:rounded-1 after:bg-[var(--data-color)] after:absolute after:bottom-0 after:left-0'
            // @ts-ignore
            style={{ "--data-color": "#c4ff89" }}
          >
            PM2.5
          </div>
          <p>
            <i>Fair</i> <i style={{ fontSize: pxChangeVw("18px") }}>32</i>
          </p>
          <p style={{ color: "#FFFFFF", opacity: 0.8 }}>8 μg/m</p>
          <p style={{ fontSize: pxChangeVw("10px") }}>
            Fine Particulate Matter are inhalable pollutant particleswith a diameter less than 2.5 microm-eters that can
            enter thel-ungs and bloodstream, result-..
          </p>
        </div>
        <div className='flex-[1] text-12 flex flex-col gap-y-8 p-[8px_8px_16px] odd:relative odd:after:content-[""] odd:after:bg-[rgba(255,255,255,0.18)] odd:after:w-1 odd:after:h-80% odd:after:absolute odd:after:right-0 odd:after:top50% odd:after:translate-y-[-50%]'>
          <div
            className='relative pb-5 w-full after:content-[""] after:w-35 after:h-2 after:rounded-1 after:bg-[var(--data-color)] after:absolute after:bottom-0 after:left-0'
            // @ts-ignore
            style={{ "--data-color": "#38D3FF" }}
          >
            PM10
          </div>
          <p>
            <i>Fair</i> <i style={{ fontSize: pxChangeVw("18px") }}>18</i>
          </p>
          <p style={{ color: "#FFFFFF", opacity: 0.8 }}>18 μg/m</p>
          <p style={{ fontSize: pxChangeVw("10px") }}>
            Fine Particulate Matter are inhalable pollutant particleswith a diameter less than 2.5 microm-eters that can
            enter thel-ungs and bloodstream, result-..
          </p>
        </div>
      </div>

      <div className='relative after:content-[""] after:bg-[transparent] w-[calc(100%-16px)] h-10 absolute left-50% bottom-0 translate-x-[-50%] flex-[1] flex'>
        <div className='flex-[1] text-12 flex flex-col gap-y-8 p-[8px_8px_16px] odd:relative odd:after:content-[""] odd:after:bg-[rgba(255,255,255,0.18)] odd:after:w-1 odd:after:h-80% odd:after:absolute odd:after:right-0 odd:after:top50% odd:after:translate-y-[-50%]'>
          <div
            className='relative pb-5 w-full after:content-[""] after:w-35 after:h-2 after:rounded-1 after:bg-[var(--data-color)] after:absolute after:bottom-0 after:left-0'
            // @ts-ignore
            style={{ "--data-color": "#C4FF89" }}
          >
            NO2
          </div>
          <p>
            <i>Fair</i> <i style={{ fontSize: pxChangeVw("18px") }}>10</i>
          </p>
          <p style={{ color: "#FFFFFF", opacity: 0.8 }}>10 μg/m</p>
          <p style={{ fontSize: pxChangeVw("10px") }}>
            Fine Particulate Matter are inhalable pollutant particleswith a diameter less than 2.5 microm-eters that can
            enter thel-ungs and bloodstream, result-..
          </p>
        </div>
        <div className='flex-[1] text-12 flex flex-col gap-y-8 p-[8px_8px_16px] odd:relative odd:after:content-[""] odd:after:bg-[rgba(255,255,255,0.18)] odd:after:w-1 odd:after:h-80% odd:after:absolute odd:after:right-0 odd:after:top50% odd:after:translate-y-[-50%]'>
          <div
            className='relative pb-5 w-full after:content-[""] after:w-35 after:h-2 after:rounded-1 after:bg-[var(--data-color)] after:absolute after:bottom-0 after:left-0'
            // @ts-ignore
            style={{ "--data-color": "#38D3FF" }}
          >
            O3
          </div>
          <p>
            <i>Fair</i> <i style={{ fontSize: pxChangeVw("18px") }}>10</i>
          </p>
          <p style={{ color: "#FFFFFF", opacity: 0.8 }}>29 μg/m</p>
          <p style={{ fontSize: pxChangeVw("10px") }}>
            Fine Particulate Matter are inhalable pollutant particleswith a diameter less than 2.5 microm-eters that can
            enter thel-ungs and bloodstream, result-..
          </p>
        </div>
      </div>
    </div>
  );
}
